<template>
    <div>
        <filter-sidebar-layout
            :filter-key="'filter-sidebar-wheel-auto'"
            :loading="loading"
            :fields="getFields"
            :disabled-values="disabledValues"
            v-on:change="filterValues()"
            v-on:submit="updateProductList"/>
    </div>
</template>

<script>
    import FilterSidebarLayout from "./FilterSidebarLayout";
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
    name: "TheFilterSidebarWheelAuto",
    components: {FilterSidebarLayout},
    computed: {
      ...mapState('sidebarAutoWheelModule', {
        paramInfo: 'paramInfo',
        loading: 'loading',
      }),
      ...mapGetters('sidebarAutoWheelModule', {
        isCurrentPossible: 'isCurrentPossible',
        getFields: 'getFields',
        disabledValues: 'getDisabledValues'
      }),
    },
    methods: {
      ...mapActions('sidebarAutoWheelModule', {
        filterValues: 'filterValues',
        updateProductList: 'updateProductList',
      }),
    }
  }
</script>